import { AccordionLOCGenerator } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/AccordionLOCGenerator'
import { Container } from '@dtx-company/design-system/src'
import { FC, useEffect } from 'react'
import { ScrollableLOCGenerator } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/ScrollableLOCGenerator'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { selectSection } from '../../machines/locg/locgSelectors'
import { useGlobalServices } from '@dtx-company/app/shared/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'

export const LoggedOutCodeGenerator: FC = () => {
  const { locgService } = useGlobalServices()
  const currentSection = useSelector(locgService, selectSection)

  useEffect(() => {
    fireAnalyticsEvent('LoggedOutGenerator_Section_View', { value: currentSection })
  }, [currentSection])

  // 2 Containers and display none/block are used to avoid initial rendering of desktop component on mobile.
  // isMobile and a single Container can't be used (see mobile screen size)
  return (
    <>
      <Container
        maxWidth="xl"
        disableGutters
        sx={{ display: { xs: 'none', md: 'block' }, visibility: { xs: 'hidden', md: 'visible' } }}
      >
        <AccordionLOCGenerator />
      </Container>
      <Container
        maxWidth="lg"
        disableGutters
        sx={{ display: { xs: 'block', md: 'none' }, visibility: { xs: 'visible', md: 'hidden' } }}
      >
        <ScrollableLOCGenerator />
      </Container>
    </>
  )
}
